import { Node } from '@tiptap/pm/model';
import {
  CustomSectionType,
  CustomSectionContentState,
} from 'api/custom-section/types';

const NON_EDITABLE_SECTIONS = [
  CustomSectionType.AccountDetails,
  CustomSectionType.MeetingDetails,
] as CustomSectionType[];

export const isContentEditable = (node: Node) => {
  if (node.attrs.contentState === CustomSectionContentState.Prompt) {
    return false;
  }

  return !NON_EDITABLE_SECTIONS.includes(
    node.attrs.sectionType as CustomSectionType,
  );
};
